import { render, staticRenderFns } from "./Alerta.vue?vue&type=template&id=0e443a4e&scoped=true"
import script from "./Alerta.vue?vue&type=script&lang=js"
export * from "./Alerta.vue?vue&type=script&lang=js"
import style0 from "./Alerta.vue?vue&type=style&index=0&id=0e443a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e443a4e",
  null
  
)

export default component.exports